import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

export interface StreamBubbleContainerProps {
  children?: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function StreamBubbleContainer({
  children,
  className,
  'data-testid': testId,
}: StreamBubbleContainerProps) {
  return (
    <div className={cn('mx-auto my-3 w-full max-w-2xl', className)} data-testid={testId}>
      {children}
    </div>
  );
}
